import { Box } from '@mui/material';
import { MouseEventHandler } from 'react';

type ContainerIconProps = {
  children: React.ReactNode;
  backgroundColor?: string;
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
};

export const ContainerIcon = ({
  children,
  backgroundColor,
  ...rest
}: ContainerIconProps) => {
  return (
    <Box
      sx={{
        mr: 2,
        borderRadius: 1.5,
        display: 'flex',
        alignItems: 'center',
        p: 1.25,
        width: 30,
        height: 30,
        backgroundColor,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
